import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品マスタプルーフ出力クラス
 *
 * @export OutputGoodsMasterProofService
 * @class OutputGoodsMasterProofService
 * @extends {PlessResponder}
 */
@Injectable()
export class OutputGoodsMasterProofService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputGoodsMasterProofService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.map(data => ({
      condition: {
        PCode: data['pcode'],
        ItemCode: data['itemCode']
      }
    }));

    return new PlessRequest({
      search: {
        GoodsList: {
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof OutputGoodsMasterProofService
   */
  execute(model: KYMW1100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW42outputGoodsMasterProof', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputGoodsMasterProofService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
